import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import type { FetchLocationAutocompleteResponse } from '@rover/types';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const LOCATION_AUTOCOMPLETE_URL: string = fullApiUrl('utilities/location-autocomplete/');

type GetArgs = {
  query: string;
  countryCode: string | null | undefined;
};

export const get = async ({
  query,
  countryCode,
}: GetArgs): Promise<FetchLocationAutocompleteResponse> => {
  const ai = getAxiosInstance();

  try {
    const { data } = await ai.get<Snakeify<FetchLocationAutocompleteResponse>>(
      LOCATION_AUTOCOMPLETE_URL,
      { params: { query, country_code: countryCode } }
    );
    return camelize(data, true);
  } catch (e: any) {
    return DefaultAPIErrorHandler(
      e,
      'There was an error while fetching location autocomplete results.'
    );
  }
};

export default { get };
